module.exports = __webpack_public_path__ + "files/265522f281f507ba520accaae137bdde.svg";